/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_H1_TextInputs */

const en_dr_proof_h1_text = /** @type {(inputs: Dr_Proof_H1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers will pay a 30% deposit up front`)
};

const id_dr_proof_h1_text = /** @type {(inputs: Dr_Proof_H1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelanggan mau membayar DP 30% di muka`)
};

/**
* | output |
* | --- |
* | "Customers will pay a 30% deposit up front" |
*
* @param {Dr_Proof_H1_TextInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_h1_text = /** @type {((inputs?: Dr_Proof_H1_TextInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_H1_TextInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_h1_text(inputs)
	return en_dr_proof_h1_text(inputs)
});